var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnchecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_359",
    "data-name": "Path 359",
    fill: "#fefeff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,0H7a3,3,0,0,1,3,3V7a3,3,0,0,1-3,3H3A3,3,0,0,1,0,7V3A3,3,0,0,1,3,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 1 C 1.897199630737305 1 1 1.897199630737305 1 3 L 1 7 C 1 8.102800369262695 1.897199630737305 9 3 9 L 7 9 C 8.102800369262695 9 9 8.102800369262695 9 7 L 9 3 C 9 1.897199630737305 8.102800369262695 1 7 1 L 3 1 M 3 0 L 7 0 C 8.65684986114502 0 10 1.34315013885498 10 3 L 10 7 C 10 8.65684986114502 8.65684986114502 10 7 10 L 3 10 C 1.34315013885498 10 0 8.65684986114502 0 7 L 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z",
    stroke: "none",
    fill: "rgba(68,74,94,0.6)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnchecked);
export default __webpack_public_path__ + "static/media/unchecked.76b9c5b6e3b6038a9d2ff39fd70adbfd.svg";
export { ForwardRef as ReactComponent };